export default {
  showCookies: false,
  accepted: false,
  checked: false
}